// extracted by mini-css-extract-plugin
export default {"wrapper":"I0-z","play":"J0-z"};